import axios from 'axios'
import CryptoJS from 'crypto-js'

export async function getClientSecret() {
    try {
        const response = await axios.get(
            `${process.env.VUE_APP_API_URL}configurations/client-secret`
        )
        if (response.data && response.data.data) {
            // 🔐 Decrypt if necessary — if backend returns encrypted data
            console.log('response data helper', response.data.data)

            const decrypted = CryptoJS.AES.decrypt(
                response.data.data,
                process.env.VUE_APP_CSK
            ).toString(CryptoJS.enc.Utf8)

            console.log('decrypted client secret', decrypted)
            return decrypted
        }
    } catch (error) {
        console.error('Failed to fetch client secret:', error)
    }
    return null
}

export async function getRecaptaToken() {
    try {
        const response = await axios.get(
            `${process.env.VUE_APP_API_URL}configurations/recaptcha-secret`
        )
        if (response.data && response.data.data) {
            // 🔐 Decrypt if necessary — if backend returns encrypted data
            const decrypted = CryptoJS.AES.decrypt(
                response.data.data,
                process.env.VUE_APP_CSK
            ).toString(CryptoJS.enc.Utf8)
            return decrypted
        }
    } catch (error) {
        console.error('Failed to fetch client secret:', error)
    }
    return null
}

export async function getMixpanalToken() {
    try {
        const response = await axios.get(
            `${process.env.VUE_APP_API_URL}configurations/mixpanel-token`
        )
        if (response.data && response.data.data) {
            const decrypted = CryptoJS.AES.decrypt(
                response.data.data,
                process.env.VUE_APP_CSK
            ).toString(CryptoJS.enc.Utf8)
            return decrypted
        }
    } catch (error) {
        console.error('Failed to fetch client secret:', error)
    }
    return null
}
